import { graphQLFetch } from "../../../utils";
import { GENERATE_EOC_HISTORY } from "../../queries";

export const getEocHistory =
  ({ companyId, projectId, forceRefresh = false }) =>
  async (dispatch, getState) => {
    if (!companyId || !projectId) {
      throw new Error(
        "companyId and projectId are required to fetch BAT report"
      );
    }

    const data = await graphQLFetch(
      GENERATE_EOC_HISTORY,
      { cId: companyId, pId: projectId },
      "query",
      getState,
      { fetchPolicy: forceRefresh ? "network-only" : "cache-first" }
    );

    const { getEocHistory } = data || {};
    return getEocHistory;
  };
